module.exports = __webpack_public_path__ + "static/media/2020.7.21家风家训活动.25c4cbb8.jpg";